import { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import logoblack from 'src/assets/product-config/logo-black.png'
import { Billet } from 'src/pages/payBillsPayInvoice'
import { DefaultLabel } from 'src/pages/receipt/PDF'
import dateToLine from 'src/utils/dateToLine'
import { documentFormatted } from 'src/utils/documentFormatted'
import { ExtractItem } from 'src/utils/extractDescription'
import toLocaleAmount from 'src/utils/toLocaleAmount'
import transactionLabel from 'src/utils/transactionLabel'
import { PixResponse } from '../ProofResponses'

export const Pix: FC<{ data: ExtractItem; closeModal: () => void }> = ({
  data,
  closeModal,
}) => {
  const user = data?.user
  const txType = data.type.toLowerCase()

  const navigate = useNavigate()

  const billet: Billet = data.data

  useEffect(() => {
    if (!txType.includes('pix') && !txType.includes('tax')) {
      navigate('/extract')
    }
  }, [txType, navigate])

  const response = data.response as PixResponse
  const label = transactionLabel(data)

  const beneficiaryName =
    data?.data?.transfer?.destination_bank_account?.beneficiaryName
  const beneficiaryDocument =
    data?.data?.transfer?.destination_bank_account?.beneficiaryDocument

  const payerName =
    data.direction === 'out'
      ? user?.name
      : data?.data?.transfer?.destination_bank_account?.beneficiaryName

  const payerDocument =
    data.direction === 'out'
      ? user?.document
      : data?.data?.transfer?.destination_bank_account?.beneficiaryDocument

  const payerAgency = data?.data?.agency
  const payerAccount = data?.data?.account
  const payerCompany = data?.data?.company

  const end2end = data?.data?.transfer?.pix_end2end_id
  return (
    <>
      <div className="w-full h-16 flex px-10 items-center bg-[#191919]">
        <span className="text-white text-xl font-bold">{label}</span>
      </div>
      <div className="w-full flex justify-center py-5">
        <img src={logoblack} alt="Logo Vilapay Invest" className="w-40 h-40" />
      </div>
      <div className="flex w-full justify-between p-10">
        <div>
          <span className="text-zinc-400 text-2xl font-bold">
            {response?.proof?.beneficiary?.holder?.name}
          </span>
          <p className="text-[#191919] text-5xl font-bold">
            R$ {toLocaleAmount(data.amount)}
          </p>
        </div>
        <span className="font-bold text-lg">{dateToLine(data.created_at)}</span>
      </div>
      <div className="flex flex-col px-10 py-4 gap-1">
        <span className="text-zinc-500 font-semibold mb-2 text-3xl">
          Pagador
        </span>
        <DefaultLabel title="NOME" value={payerName} />
        <DefaultLabel
          title="Documento"
          value={documentFormatted(payerDocument)}
        />
        <DefaultLabel title="INSTITUIÇÃO" value={payerCompany} />
        <DefaultLabel title="Agência" value={payerAgency} />
        <DefaultLabel title="Conta" value={payerAccount} />
      </div>
      <div className="flex flex-col px-10 py-4 gap-1">
        <span className="text-zinc-500 font-semibold mb-2 text-3xl">
          Favorecido
        </span>
        <DefaultLabel title="NOME" value={beneficiaryName} />
        <DefaultLabel
          title={beneficiaryDocument?.length > 11 ? 'CNPJ' : 'CPF'}
          value={documentFormatted(beneficiaryDocument)}
        />
        {end2end && <DefaultLabel title="End2EndID" value={end2end} />}
      </div>
    </>
  )
}
